/** http 包内使用的公共文案（与 @repo/i18n common 保持一致，仅保留本包引用到的 key） */
export default {
  requestCode: {
    dlsxqcxdl: 'Login expired, please re-login',
  },
  tradeDialog: {
    toastFreezeText: 'Submission failed! Account frozen, contact support.',
  },
}
